import React, {useEffect, useState} from 'react';
import IMWebView from './im-webview';
import {imManager} from './im.state';

export function ImBox() {
  const [visibleState, setVisibleState] = useState(
    imManager.getState().visibleState,
  );
  useEffect(() => {
    const visibilitySubscription = imManager.visibleState.subscribe(value => {
      setVisibleState(value);
    });
    return () => {
      visibilitySubscription.unsubscribe();
    };
  }, []);
  return (
    <div
      className="w-full h-full absolute left-0 top-0 z-50"
      style={{display: visibleState.isVisible ? 'block' : 'none'}}>
      <IMWebView />
    </div>
  );
}
